import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import './MarkdownView.css';

interface MarkdownViewProps {
  content: string;
  className?: string;
}

const sanitizeSchema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    img: ['src', 'alt', 'title', 'width', 'height'],
    a: ['href', 'title', 'target', 'rel'],
    input: ['type', 'checked', 'disabled'],
    td: ['align', 'valign'],
    th: ['align', 'valign'],
    code: ['className'],
  },
  tagNames: [
    ...(defaultSchema.tagNames || []),
    'img',
    'input',
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
    'del',
  ],
};

const MarkdownView: React.FC<MarkdownViewProps> = ({ content, className }) => {
  if (!content) return null;

  return (
    <div className={`markdown-view ${className || ''}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[[rehypeSanitize, sanitizeSchema]]}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownView;
